import { Injectable } from '@angular/core';
import { Router, NavigationExtras, UrlTree } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AppRouter extends Router {
  static navigationParams(extras: NavigationExtras = {}) {
    return {
      ...extras,
      queryParams: {
        ...extras.queryParams,
        ...(localStorage.getItem('provider') ? { provider: localStorage.getItem('provider') } : {}),
      },
    };
  }

  override navigate(commands: unknown[], extras: NavigationExtras = {}): Promise<boolean> {
    return super.navigate(commands, AppRouter.navigationParams(extras));
  }

  override navigateByUrl(url: string | UrlTree, extras: NavigationExtras = {}): Promise<boolean> {
    return super.navigateByUrl(url, AppRouter.navigationParams(extras));
  }
}
